/* OHROSE — looping rails.
   Native scroll + cloned buffers, the same mechanic the UGC section uses.
   No Slick, no Swiper, no second carousel library: this drives the existing
   overflow-scroll rails so touch, trackpad and keyboard all keep working and
   vertical page scroll is never trapped.

   A rail opts in with data-ohr-rail. Arrows are injected only when the content
   actually overflows. */
(function () {
  if (window.OhrRail) return;
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');

  function Rail(el) {
    this.viewport = el;
    this.originals = Array.prototype.slice.call(el.children);
    this.n = this.originals.length;
    this.loop = el.dataset.ohrLoop !== 'false';
    this.clones = [];
    this.pre = 0;
    this.setW = 0;
    if (!this.n) return;
    el.__ohrRail = this;
    this.build();
    this.bind();
  }

  Rail.prototype = {
    measure: function () {
      var cs = getComputedStyle(this.viewport);
      this.gap = parseFloat(cs.columnGap || cs.gap) || 0;
      var first = this.originals[0];
      this.slideW = first ? first.getBoundingClientRect().width : 0;
      this.setW = this.n * (this.slideW + this.gap);
      this.overflowing = this.viewport.scrollWidth - this.viewport.clientWidth > 4;
    },

    build: function () {
      var i, self = this;
      this.clones.forEach(function (c) { c.remove(); });
      this.clones = [];
      this.pre = 0;
      this.measure();
      if (!this.viewport.clientWidth) return;      // not laid out yet
      if (!this.loop || !this.overflowing || !this.setW) return;

      var vw = this.viewport.clientWidth;
      this.pre = Math.max(1, Math.ceil(vw / this.setW) + 1);
      var post = this.pre;
      var mk = function (frag) {
        for (var j = 0; j < self.n; j++) {
          var c = self.originals[j].cloneNode(true);
          c.setAttribute('data-ohr-clone', '');
          c.setAttribute('aria-hidden', 'true');
          Array.prototype.forEach.call(c.querySelectorAll('a,button'), function (a) { a.tabIndex = -1; });
          self.clones.push(c);
          frag.appendChild(c);
        }
      };
      var frag = document.createDocumentFragment();
      for (i = 0; i < this.pre; i++) mk(frag);
      this.viewport.insertBefore(frag, this.originals[0]);
      frag = document.createDocumentFragment();
      for (i = 0; i < post; i++) mk(frag);
      this.viewport.appendChild(frag);
      this.jump(this.pre * this.setW);
    },

    /* A jump is our own scroll, not the shopper's. Gate on a timestamp: a
       boolean cleared in a callback latches on if that callback is delayed,
       and a latched flag disables loop normalisation permanently. */
    isJumping: function () { return Date.now() - (this._jumpAt || 0) < 60; },

    jump: function (v) {
      var vp = this.viewport;
      this._jumpAt = Date.now();
      var snap = vp.style.scrollSnapType, beh = vp.style.scrollBehavior;
      vp.style.scrollSnapType = 'none';
      vp.style.scrollBehavior = 'auto';
      vp.scrollLeft = v;
      requestAnimationFrame(function () {
        vp.style.scrollSnapType = snap;
        vp.style.scrollBehavior = beh;
      });
    },

    normalize: function () {
      if (!this.pre || !this.setW) return;
      var lo = this.pre * this.setW, hi = lo + this.setW, sl = this.viewport.scrollLeft;
      if (sl >= lo && sl < hi) return;
      var off = ((sl - lo) % this.setW + this.setW) % this.setW;
      this.jump(lo + off);
    },

    step: function (dir) {
      if (!this.slideW) this.measure();
      if (this.pre) this.normalize();
      var one = this.slideW + this.gap;
      var target = this.viewport.scrollLeft + dir * one;
      if (!this.pre) {
        var max = this.viewport.scrollWidth - this.viewport.clientWidth;
        target = Math.max(0, Math.min(max, target));
      }
      this.viewport.scrollTo({ left: target, behavior: RM.matches ? 'auto' : 'smooth' });
    },

    bind: function () {
      var self = this;
      this.viewport.addEventListener('scroll', function () {
        if (self.isJumping() || !self.pre) return;
        clearTimeout(self._idle);
        self._idle = setTimeout(function () { self.normalize(); }, 110);
      }, { passive: true });
      if ('onscrollend' in window) {
        this.viewport.addEventListener('scrollend', function () {
          if (!self.isJumping()) self.normalize();
        });
      }
      this.viewport.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); self.step(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); self.step(-1); }
      });

      var wrap = this.viewport.closest('[data-ohr-rail-wrap]') || this.viewport.parentElement;
      if (wrap) {
        var prev = wrap.querySelector('[data-ohr-prev]');
        var next = wrap.querySelector('[data-ohr-next]');
        if (prev) prev.addEventListener('click', function () { self.step(-1); });
        if (next) next.addEventListener('click', function () { self.step(1); });
        this.prev = prev; this.next = next;
        this.syncArrows();
      }

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(function () {
          clearTimeout(self._rt);
          self._rt = setTimeout(function () { self.build(); self.syncArrows(); }, 150);
        });
        this.ro.observe(this.viewport);
      }
    },

    syncArrows: function () {
      this.measure();
      var show = this.overflowing;
      if (this.prev) this.prev.hidden = !show;
      if (this.next) this.next.hidden = !show;
    }
  };

  window.OhrRail = Rail;
  window.ohrRailInit = function (scope) {
    var els = (scope || document).querySelectorAll('[data-ohr-rail]');
    Array.prototype.forEach.call(els, function (el) { if (!el.__ohrRail) new Rail(el); });
  };
  document.addEventListener('shopify:section:load', function (e) { window.ohrRailInit(e.target); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { window.ohrRailInit(document); });
  } else {
    window.ohrRailInit(document);
  }
})();


/* Item 8 — sticky reveal. The theme's own sticky-header element never applies
   a class, so the on-scroll-up behaviour is driven here: hide going down,
   reveal going up, always visible near the top. */
(function () {
  if (window.__ohrSticky) return;
  window.__ohrSticky = true;
  var run = function () {
    var el = document.querySelector('sticky-header.header-wrapper');
    if (!el) return;
    var last = window.pageYOffset || 0;
    var onScroll = function () {
      var y = window.pageYOffset || 0;
      if (y < 120) { el.classList.remove('ohr-header--hidden'); last = y; return; }
      if (y > last + 6) el.classList.add('ohr-header--hidden');
      else if (y < last - 6) el.classList.remove('ohr-header--hidden');
      last = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

/* Item 21 — "Style it with" Add. A single-variant row adds straight to cart and
   opens the theme's own cart drawer; a multi-variant row is a link to the
   product, so nobody has a size chosen for them. */
(function () {
  // R9 shared failure surface for this rail's add-to-cart.
  function fail(btn, msg) {
    btn.removeAttribute('aria-busy');
    btn.setAttribute('data-ohr-error', '1');
    var prev = btn.getAttribute('data-ohr-label') || btn.textContent;
    btn.setAttribute('data-ohr-label', prev);
    btn.textContent = msg || 'Unavailable';
    setTimeout(function () {
      btn.textContent = btn.getAttribute('data-ohr-label') || prev;
      btn.removeAttribute('data-ohr-error');
    }, 2600);
  }
  if (window.__ohrPuAdd) return;
  window.__ohrPuAdd = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pu-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    btn.setAttribute('aria-busy', 'true');
    btn.removeAttribute('data-ohr-error');
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) {
      btn.removeAttribute('aria-busy');
      // R9: /cart/add.js answers 422 for sold-out, capped or invalid variants.
      // This used to `return` silently — the button flickered and nothing else
      // happened, with no reason given. Say what went wrong on the button.
      if (!r.ok) {
        return r.json().then(function (d) { fail(btn, (d && (d.description || d.message)) || null); })
                       .catch(function () { fail(btn, null); });
      }
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
      else window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
    }).catch(function () { fail(btn, null); });
  });
})();
